import { useQuery } from '@tanstack/react-query';
import { customAxios } from '../../lib/axios';

interface WorkingHours {
  startTime: string;
  endTime: string;
  totalHours: number;
  _id: string;
}

interface WorkingHoursResponse {
  success: boolean;
  data: {
    configSource: string;
    workingHoursConfig: WorkingHours;
  };
}

const getUserTotalWorkingHours = async (userId?: string): Promise<WorkingHours> => {
  const params = new URLSearchParams();
  if (userId) {
    params.append('userId', userId);
  }
  const { data } = await customAxios.get<WorkingHoursResponse>(
    `/attendance/getWorkingHoursConfig${params.toString() ? `?${params.toString()}` : ''}`
  );
  return data.data.workingHoursConfig;
};

export const useGetTotalHour = (userId?: string) =>
  useQuery<WorkingHours>({
    queryKey: ['totalHours', userId],
    queryFn: () => getUserTotalWorkingHours(userId),
  });
